import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService, FnSelectModule } from 'foundation';
import { EOTeam, EOSchemaTeam } from '../../../../modal/entity.modal';
import { PosHttpService } from '../../../../services/pos.http.service';

@Component({
  selector: 'app-schema-team-model',
  templateUrl: './schema-team.component.html',
  styleUrl: './schema-team.component.scss'
})
export class SchemaTeamModelComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private dialogRef: MatDialogRef<SchemaTeamModelComponent>, private fnutilservice: FnUtilService, private toaster: FnToasterService, private posHttpSvcs : PosHttpService) {
    if (!this.fnutilservice.isEmptyObject(this.dialogData.eoSchema)) {
      this.objectHash.primaryKey=this.dialogData.eoSchema.primaryKey;
      this.objectHash.schemaName = this.dialogData.eoSchema.schemaName;
      this.objectHash.teams = this.fnutilservice.arrayFromArrayOfMap(this.dialogData.eoSchema.teams,'primaryKey');
    }
  }
  ngOnInit(): void {
   this.loadTeamArray();
  }

  teamsArray: EOTeam []=[];
  objectHash :EOSchemaTeam= {
    primaryKey:0,
    schemaName: '',
    teams:[]
  }
 
  close() {
    this.dialogRef.close();
  }


  loadTeamArray(){
    this.posHttpSvcs.authGet('v1/ui/getEOTeamArray', 'getEOTeamArray').subscribe((resp =>{
      if(resp.isError){
        this.toaster.error("EOTeamArray is not loaded");
      }
      this.teamsArray = resp.data;
    }))
  }
  

  add() {
    if (this.fnutilservice.isEmptyObject(this.objectHash.schemaName)) {
      this.toaster.error('SchemaName can not be null');
      throw new Error();
    }
    this.dialogRef.close(this.objectHash);
  }

}
interface HwDialogData {
  eoSchema: any;
}